/**
 * Holds the page still behind a full-screen panel.
 *
 * Only where the panel covers the page. There the document underneath is not
 * something the reporter can be reaching for, so a drag landing on the tab
 * strip or the composer — neither of which scrolls — must not take the page
 * with it. On desktop the panel is a card beside the page being reported, the
 * page stays readable on purpose, and nothing is locked.
 *
 * Not a Modal, deliberately (see the panel's own docstring): this locks the
 * scroll and nothing else — no backdrop, no focus trap.
 */
import { useEffect } from "react";

export const useSupportScrollLock = (isLocked: boolean): void => {
	useEffect(() => {
		if (!isLocked) return;
		const previous = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = previous;
		};
	}, [isLocked]);
};
